var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-media-filter"},[_vm._l((_vm.filterLayout),function(item){return [_c(item,{tag:"component"})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }